import React from 'react';
import { useInstallPrompt } from '../../hooks/useInstallPrompt';
import LOGO from '../../images/logo.webp';
import styles from '../../styles/InstallAppBanner.module.scss';

const InstallAppBanner = () => {
  const { visible, iosHint, canInstall, dismiss, install } = useInstallPrompt();

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.banner} role="region" aria-label="Встановлення застосунку">
      <div className={styles.content}>
        <img
          src={LOGO}
          alt=""
          className={styles.logo}
          width={56}
          height={43}
          decoding="async"
          aria-hidden="true"
        />
        <div className={styles.text}>
          <p className={styles.title}>Встановіть ARKDetali</p>
          <p className={styles.subtitle}>
            {iosHint
              ? 'Натисніть «Поділитися» і оберіть «На головний екран»'
              : 'Швидкий доступ до каталогу прямо з робочого столу'}
          </p>
        </div>
        <div className={styles.actions}>
          {canInstall && (
            <button type="button" className={styles.installBtn} onClick={install}>
              Встановити
            </button>
          )}
          <button
            type="button"
            className={styles.closeBtn}
            onClick={dismiss}
            aria-label="Закрити"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallAppBanner;
